import React from 'react'
import { Typography } from '@mui/material'
import { EdgePanel } from '../'
import makeStyles from '@mui/styles/makeStyles'

export const useStyles = makeStyles(({ spacing, palette }) => ({
  header: {
    fontSize: '1.125rem',
    fontWeight: 700
  },
  list: {
    '& *': {
      fontSize: '0.875rem'
    }
  },
  content: {
    padding: spacing(2),
    backgroundColor: palette.common.white
  }
}))

const SearchSuggestions = props => {
  const classes = useStyles()

  return (
    <EdgePanel>
      <Typography className={classes.header}>Search suggestions:</Typography>
      <ul className={classes.list}>
        <Typography component='li'>
          Make sure keywords are spelled correctly
        </Typography>
        <Typography component='li'>Try rephrasing or using synonyms</Typography>
        <Typography component='li'>Use less specific keywords</Typography>
      </ul>
    </EdgePanel>
  )
}

export default SearchSuggestions
